import { render, staticRenderFns } from "./deliveryUnitDistribution2.vue?vue&type=template&id=1e0f803a&scoped=true&"
import script from "./deliveryUnitDistribution2.vue?vue&type=script&lang=js&"
export * from "./deliveryUnitDistribution2.vue?vue&type=script&lang=js&"
import style0 from "./deliveryUnitDistribution2.vue?vue&type=style&index=0&id=1e0f803a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0f803a",
  null
  
)

export default component.exports